import {
  EvaluationContextFieldOverrideFragment,
  ListEvaluationContextFieldOverridesQuery,
  useListEvaluationContextFieldOverridesQuery,
  withStandardListHook,
} from '@spotify/confidence-graphql';

export const useEvaluationContextFieldOverrides = withStandardListHook<
  ListEvaluationContextFieldOverridesQuery,
  EvaluationContextFieldOverrideFragment,
  'evaluationContextFieldOverrides'
>(
  useListEvaluationContextFieldOverridesQuery,
  'evaluationContextFieldOverrides',
);
